// extracted by mini-css-extract-plugin
export default {"fadeIn":"layout_fadeIn__E2Tbb","fadeOutMain":"layout_fadeOutMain__Tiw64","fadeOutDown":"layout_fadeOutDown__Z8X4C"};